/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import DOMPurify from 'dompurify';
import { get, keyBy, isEmpty } from 'lodash';
import { Row } from 'react-bootstrap';
import RichTextDisplay from '../../components/RichTextDisplay';
import TrackPlayerSlideComponent from '../../hocs/TrackPlayerSlideComponent';
import VerbRadioInput from '../../components/formComponents/inputs/VerbRadioInput';
import VerbText from '../../components/VerbText';

import { CORRECT_ANSWER_FEEDBACK, INCORRECT_ANSWER_FEEDBACK, SECTION_ITEM_TYPES } from '../../Constants';

class ChooseOneQuizSlide extends Component {
    static propTypes = {
        content: PropTypes.shape({
            options: PropTypes.array,
            description: PropTypes.string,
            answerFeedback: PropTypes.string,
            displayType: PropTypes.string
        }),
        sectionItems: PropTypes.array,
        completedData: PropTypes.object,
        currentSectionItem: PropTypes.object,
        currentUser: PropTypes.object,
        name: PropTypes.string,
        canMoveToNext: PropTypes.func,
        onChange: PropTypes.func,
        nextSectionName: PropTypes.string,
        isUpdatingUserTrack: PropTypes.bool,
        handleAwaitingSubmitState: PropTypes.func,
        handleOptionSelect: PropTypes.func,
        onAnswerSubmit: PropTypes.func,
        slideIsAwaitingSubmit: PropTypes.bool,
        sendWorkspaceSegementEvent: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            selectedAnswerId: '',
            choicesById: {},
            quizAnswerSubmitted: false,
            correctAnswerFeedback: '',
            incorrectAnswerFeedback: ''
        };
    }

    UNSAFE_componentWillMount() {
        const {
            canMoveToNext,
            handleAwaitingSubmitState,
            handleOptionSelect,
            completedData = {},
            content: { options = [] }
        } = this.props;
        const choicesById = keyBy(options, 'id', {});
        const answer = get(completedData, 'data.id', '');
        const correctAnswerFeedbackIndex = Math.floor(Math.random() * CORRECT_ANSWER_FEEDBACK().length);
        const incorrectAnswerFeedbackIndex = Math.floor(Math.random() * INCORRECT_ANSWER_FEEDBACK().length);

        if (!isEmpty(completedData)) {
            handleAwaitingSubmitState(false);
            handleOptionSelect(true);
            canMoveToNext(true);
        } else {
            handleAwaitingSubmitState(true);
            handleOptionSelect(false);
        }

        this.setState({
            selectedAnswerId: answer,
            quizAnswerSubmitted: !!answer,
            choicesById,
            correctAnswerFeedback: CORRECT_ANSWER_FEEDBACK()[correctAnswerFeedbackIndex],
            incorrectAnswerFeedback: INCORRECT_ANSWER_FEEDBACK()[incorrectAnswerFeedbackIndex]
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { slideIsAwaitingSubmit } = this.props;

        if (slideIsAwaitingSubmit && !nextProps.slideIsAwaitingSubmit) {
            this.submitSlideAnswer();
        }
    }

    handleSelect = (optionId) => {
        const { handleOptionSelect } = this.props;
        this.setState({ selectedAnswerId: optionId });
        handleOptionSelect(true);
    };

    submitSlideAnswer = () => {
        const { onChange, onAnswerSubmit, isUpdatingUserTrack } = this.props;
        const { selectedAnswerId, choicesById } = this.state;
        const answerIsCorrect = selectedAnswerId && choicesById[selectedAnswerId].isCorrect === true;
        const isCompletedAndAnswered = !!selectedAnswerId;

        const data = {
            id: selectedAnswerId,
            isCorrect: answerIsCorrect
        };

        if (onChange) {
            onChange(data, isCompletedAndAnswered, isCompletedAndAnswered);
        }

        if (!isUpdatingUserTrack && selectedAnswerId) {
            this.setState({
                quizAnswerSubmitted: true
            });
            onAnswerSubmit();
        }
    };

    _renderOptions = (options) => {
        const { selectedAnswerId, quizAnswerSubmitted, correctAnswerFeedback, incorrectAnswerFeedback } = this.state;

        const radioOptions = options.map((option) => ({
            ...option,
            value: option.id
        }));

        return (
            <VerbRadioInput
                value={selectedAnswerId}
                options={radioOptions}
                answerSubmitted={quizAnswerSubmitted}
                displayAnswerFeedback={true}
                correctAnswerFeedback={correctAnswerFeedback}
                incorrectAnswerFeedback={incorrectAnswerFeedback}
                onChange={this.handleSelect.bind(this)}
                displayRichText={true}
            />
        );
    };

    _renderAnswerFeedbackSection = () => {
        const {
            content: { answerFeedback }
        } = this.props;
        const { selectedAnswerId, quizAnswerSubmitted } = this.state;

        if (selectedAnswerId && quizAnswerSubmitted && answerFeedback) {
            return (
                <div
                    className={'answer-feedback'}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(answerFeedback) }}
                />
            );
        }
        return null;
    };

    _getQuizCountObject = () => {
        const { sectionItems = [] } = this.props;
        const quizCountObject = {
            totalItemsCount: 0,
            questionIndexes: {}
        };

        sectionItems.forEach((item) => {
            if (item.type.toLocaleUpperCase() === SECTION_ITEM_TYPES.CHOOSE_ONE_QUIZ) {
                quizCountObject.totalItemsCount += 1;
                quizCountObject.questionIndexes[item.id] = quizCountObject.totalItemsCount;
            }
        });

        return quizCountObject;
    };

    render() {
        const {
            currentUser,
            name,
            currentSectionItem,
            nextSectionName,
            content: { displayType = '', options = [], description = '' },
            sendWorkspaceSegementEvent
        } = this.props;
        const quizCountObject = this._getQuizCountObject();
        return (
            <div className={'choose-one-quiz-slide'}>
                <h1 className={'chooseSlide-title verb-title-1 playerHeader'}>
                    {name}
                    <span className={'choose-one-quiz-slide-progress'}>
                        <VerbText
                            messageId={'WORKSPACE_THIS_OR_THAT_PROGRESS'}
                            defaultMessage={'{currentQuestionNumber} of {totalQuestionNumber}'}
                            valuesToInject={{
                                currentQuestionNumber: quizCountObject.questionIndexes[currentSectionItem.id],
                                totalQuestionNumber: quizCountObject.totalItemsCount
                            }}
                        />
                    </span>
                </h1>
                <div className={cns('chooseSlide-options', 'playerContent')}>
                    <RichTextDisplay
                        className={'playerDescription'}
                        htmlToDisplay={description}
                        currentUser={currentUser}
                        nextSectionName={nextSectionName}
                        sendSegementEvent={sendWorkspaceSegementEvent}
                    />
                    <Row>
                        <div
                            className={cns(
                                'options',
                                { 'chooseSlide-options-images': displayType === 'image' },
                                'col-12'
                            )}
                        >
                            {this._renderOptions(options)}
                        </div>
                    </Row>
                    <Row>
                        <div className={'col-sm-12 col-12'}>{this._renderAnswerFeedbackSection()}</div>
                    </Row>
                </div>
            </div>
        );
    }
}

export const ChooseOneQuizSlideComponent = ChooseOneQuizSlide;
export default TrackPlayerSlideComponent(ChooseOneQuizSlide);
